/**
 * @module Components.Loading
 *
 */
export { default as Dots } from './Dots';
export { default as Spinner } from './Spinner';
